module.exports = __webpack_public_path__ + "c_static/img/location_message.be30399.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/location_message.png
// module id = fwF+
// module chunks = 33